<template>
  <div class="block-chain-org-manage">
    <action-bar>
      <search v-model="inputContent" placeholder="请输入组织名" @onSearch="handleSearch"></search>
    </action-bar>
    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="list"
      :paging="paging"
      @pagination="handleSizeOrPageChange"
    >
    </normal-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Index',
  data() {
    return {
      inputContent: '',
      // 设置table的列
      tableCol: [
        { prop: 'OrgId', label: '组织ID' },
        { prop: 'OrgName', label: '组织名称' },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row.createAt)
          }
        },
        { prop: 'NodeNum', label: '节点数' }
      ]
    }
  },
  computed: {
    ...mapState({
      list: state => state.chain.chain_org_list,
      paging: state => state.chain.chain_org_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getChainOrgLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        chainId: this.$route.query.chainId,
        name: this.inputContent
      }
      this.getChainOrgLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    refresh() {
      this.inputContent = ''
      this.getList()
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },
    handleSearch(value) {
      this.inputContent = value
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('block-chain-org-manage', (), ());
.block-chain-org-manage {
  @include adaptation(
    (
      --block-chain-org-manage-unavaliable-height: 166px
    )
  );
  --block-chain-org-manage-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--block-chain-org-manage-unavaliable-height)
  );
  .btn-list-style {
    width: 100%;
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--block-chain-org-manage-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--block-chain-org-manage-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--block-chain-org-manage-min-height);
      }
    }
  }
}
</style>
